module.exports = __webpack_public_path__ + "static/media/icon_advice.bc43db00.svg";